import { Loader } from "@mantine/core";
import type React from "react";

interface LoadingStateProps {
  message?: string;
  className?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({ message = "Loading...", className }) => (
  <div
    className={`text-center text-muted-foreground py-10 text-base${className ? ` ${className}` : ""}`}
  >
    <Loader color="blue" className="mx-auto mb-4" />
    {message}
  </div>
);

export default LoadingState;
